import {
	getGetVenueQueryOptions,
	getListSpacesQueryOptions,
	listVenues,
} from '@cocoonspace/sdk-js/domains/spaces/spaces'
import { defaultI18nNs } from '@cocoonspace/shared/config/default-i-18-n-ns-config'
import { dehydrate, QueryClient } from '@tanstack/react-query'
import type { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { VenueDetailsPage } from '~/domains/spaces/components/venue-details/venue-details'

export default VenueDetailsPage

export const getStaticProps: GetStaticProps = async ({ locale, params }) => {
	const queryClient = new QueryClient()

	try {
		const venueData = await queryClient.fetchQuery(
			getGetVenueQueryOptions(params?.slug as string),
		)

		await queryClient.fetchQuery(
			getListSpacesQueryOptions({
				venues: [venueData.data.id],
			}),
		)

		return {
			props: {
				...(await serverSideTranslations(locale as string, [
					...defaultI18nNs,
					'space',
					'cwDistricts',
					'cwCommon',
					'venue',
				])),
				dehydratedState: dehydrate(queryClient),
			},
			revalidate: 24 * 60 * 60, // 24h
		}
	} catch (e) {
		return { notFound: true }
	}
}

export const getStaticPaths = async () => {
	const venuesData = await listVenues()

	return {
		paths: [
			...venuesData.data.map(({ slug }) => ({
				params: { slug },
			})),
		],
		fallback: 'blocking',
	}
}
